import { toast } from "react-toastify";
import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface ComparedReportedIssuesState {
  comparedissue: {
    load: boolean;
    data: [];
  };
}

export const ComparedReportedIssueSlice = createSlice({
  name: "comparedissue",
  initialState: {
    comparedissue: {
      load: false,
      data: [],
    },
  } as ComparedReportedIssuesState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchComparedReportedIssuesList.pending, (state: ComparedReportedIssuesState) => {
        state.comparedissue.load = true;
      })
      .addCase(fetchComparedReportedIssuesList.fulfilled, (state: ComparedReportedIssuesState, action: any) => {
        state.comparedissue.data = action.payload;
        state.comparedissue.load = false;
      })
      .addCase(fetchComparedReportedIssuesList.rejected, (state: ComparedReportedIssuesState) => {
        state.comparedissue.load = false;
      });
  },
});

export default ComparedReportedIssueSlice.reducer;

export const fetchComparedReportedIssuesList = createAsyncThunk(
  "comparedissue/fetchComparedReportedIssuesList",
  async (param: {apiParam: {per_page: any, page: any, status: any, search: any, warehouse_id: any, project_pin: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post(`api/getTpiIssuesWithDuplicatesPartialData`, {
        warehouse_id: param.apiParam.warehouse_id,
        status: param.apiParam.status,
        per_page: param.apiParam.per_page,
        page: param.apiParam.page,
        search: param.apiParam.search,
        project_pin: param.apiParam.project_pin
      });
      return data.data;
    } catch (error) {
    }
  }
);

export const AutoVerifyIssuse = createAsyncThunk(
  "comparedissue/AutoVerifyIssuse",
  async (param: {apiParam: {login_user_id: any, warehouse_id: any, project_pin: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post(`api/autoVerifyUniqueIssue`, {
        warehouse_id: param.apiParam.warehouse_id,
        login_user_id: param.apiParam.login_user_id,
        project_pin: param.apiParam.project_pin
      });

      toast.success(data.message,{theme: "colored"});

      return data.data;
    } catch (error) {
    }
  }
);
